import useEntity from "../../hooks/useLog";
import LogDetail from "../../components/log/LogDetail/LogDetail";
import LogScoped from "../../components/log/LogDetail/LogScoped";
import LogTabs from "../../components/log/LogDetail/LogTabs";
import { useGetLogQuery } from "../../apis/Log.api";
import { PrimaryLog } from "../../types/models/Log";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const LogDetailPage = () => {

    useTitle(t`Details Log`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { logId: id } = useParams();

    const { data, refetch } = useGetLogQuery(PrimaryLog.fromPath(id))
    const { deleteLog } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteLog(data, '..')
    }, [data, deleteLog])

    if (id === 'scoped') {
        return (<LogScoped/>)
    }

    return (
        <Box data-testid="Log-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <LogDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Logs/update/view'
        ) ||
false) &&
                        !(data?.shipmentId)
                        &&
                        <Button size="small" variant="outlined" data-testid="Log-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Logs/delete/view'
        ) ||
false) &&
                        !(data?.shipmentId)
                        &&
                        <Button size="small" color="error" variant="outlined" data-testid="Log-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <LogTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default LogDetailPage;
